import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

export const SET_TIPO_AMOSTRA = "setListTipoAmostra"
export const SET_MESSAGE_ALERT = 'setMensagem'

const actions = {

    //#region  tipo_amostra
    async create_tipo_amostra(context, value) {
        let message = await ApiService.post('tipo_amostra', value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    async update_tipo_amostra(context, value) {
        const id = value.id
        delete(value.id)
        let message = await ApiService.put('tipo_amostra/atualizar/' + id, value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    async bloquear_tipo_amostra(context, value) {
        let message = await ApiService.get('tipo_amostra/bloquear/' + value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    async desbloquear_tipo_amostra(context, value) {
        let message = await ApiService.get('tipo_amostra/desbloquear/' + value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    async delete_tipo_amostra(context, value) {
        let message = await ApiService.get('tipo_amostra/deletar/' + value)
            .then(response => ({ tipo: 'success', message: response.data }))
            .catch((error) => ({ tipo: 'error', message: error.response.data }))
        context.commit(SET_MESSAGE_ALERT, message)
    },
    async listar_tipo_amostras(context, params) {
        await ApiService.get('tipo_amostra')
            .then(response => context.commit(SET_TIPO_AMOSTRA, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },
    async listar_tipo_amostras_ativos(context, params) {
        await ApiService.get('tipo_amostra/ativos')
            .then(response => context.commit(SET_TIPO_AMOSTRA, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },
    async pesquisar_tipo_amostras(context, params) {
        await ApiService.get('tipo_amostra/filtro/' + params)
            .then(response => context.commit(SET_TIPO_AMOSTRA, response.data))
            .catch((error) => context.commit(SET_MESSAGE_ALERT, {
                tipo: 'error', message: error.response.data
            }))
    },

    //#endregion




};

const getters = {};

const mutations = {
    [SET_TIPO_AMOSTRA](state, value) {
        state.lista_tipo_amostras = value
    },


    [SET_MESSAGE_ALERT](state, value) {
        console.log(value)
        let customMessage;
        if (typeof value.message === "object") {
            customMessage = value.message.msg;
        }
        state.mensagem_alert = {
            tipo: value.tipo,
            message: customMessage ? customMessage : value.message,
        };
    },
};

const state = {
    lista_tipo_amostras: [],
    mensagem_alert: "",


};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};